<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  outlined

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_MS = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Je Komponenteninstanz eigener Timer und eigene Anfragefolge
    this.timeout = null;
    this.requestSeq = 0;
    this.destroyed = false;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.stopPending();
  },

  watch: {
    search(val) {
      if (!val) {
        this.stopPending();
        this.items = [];
        return;
      }

      if (this.select && typeof this.select === "object" && val === this.select.text) {
        this.stopPending();
        return;
      }

      val !== this.select && this.querySelections(val) // eslint-disable-line
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Timer und laufende Anfrage beenden, verspätete Antworten verwerfen
    stopPending() {
      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.requestSeq++;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopPending();

      const seq = this.requestSeq;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoderReady.then(geocoder => {
          if (this.destroyed || seq !== this.requestSeq) {
            return null;
          }

          return geocoder.autocomplete(value);
        }).then(items => {
          if (this.destroyed || seq !== this.requestSeq || !items) {
            return;
          }

          this.items = items.slice();
        }).catch(err => {
          if (this.destroyed || seq !== this.requestSeq || (err && err.cancelled)) {
            return;
          }

          this.items = [];
        }).finally(() => {
          if (!this.destroyed && seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, DEBOUNCE_MS);
    },

    change(o) {
      this.stopPending();
      this.$emit("change", o);
    }
  }
};
</script>
